module.exports = __webpack_public_path__ + "static/media/ic_splash_graphic_iphone@2x.fe028ce6.png";